import { IntentFilterSelect } from '@ipfabric/ui-components/IntentFilterSelect/IntentFilterSelect';
import type { IntentFilterSelectOptions } from '@ipfabric/ui-components/IntentFilterSelect/IntentFilterSelect.types';
import { type ReportSeverityKey, reportSeverities } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useApiTableContextSelectors } from 'components/ApiTable/model/ApiTableModel';
import { useMemo } from 'react';
import type { FC } from 'react';

interface Props {
  onValueChange: (value: string) => void;
  value: string;
  column: string;
}

export const ColorFilterRule: FC<Props> = (props) => {
  const ctxProps = useApiTableContextSelectors({
    reports: prop('tableModel', 'reports'),
  });

  const handleChange = (filterValue: ReportSeverityKey | null) => {
    props.onValueChange(filterValue?.toString() ?? '');
  };

  const options = useMemo(() => {
    const columnReports = ctxProps.reports?.[props.column];
    return reportSeverities.reduce<IntentFilterSelectOptions>(
      (acc, severity) => {
        const severityKey = severity.toString() as ReportSeverityKey;
        acc[severityKey] = columnReports?.descriptions?.checks?.[severityKey];
        return acc;
      },
      {},
    );
  }, [props.column, ctxProps.reports]);

  const value = props.value as ReportSeverityKey | '';

  return (
    <div className='flex h-8 items-center'>
      <IntentFilterSelect
        className='flex-fixed mr-2'
        value={value === '' ? null : value}
        onChange={handleChange}
        options={options}
      />
    </div>
  );
};
